var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.472 0c.2.002.393.083.533.228l1.945 1.998c.025.026.025.026.087.097l.049.087.025.05a.44.44 0 0 1 .038.135c.02.085.026.12.025.17a.458.458 0 0 1-.015.12.677.677 0 0 1-.042.163.508.508 0 0 1-.087.143.412.412 0 0 1-.075.101 1.231 1.231 0 0 0-.364.877c0 .331.129.641.363.876.235.235.545.364.876.364.332 0 .642-.13.88-.367a.391.391 0 0 1 .094-.07c.07-.052.1-.07.144-.088a.438.438 0 0 1 .129-.034.51.51 0 0 1 .29-.007c.084.014.108.02.145.035.053.02.086.04.132.075.061.037.083.053.12.088l2.008 1.954a.748.748 0 0 1 .008 1.07l-3.719 3.717-.14-.14a.751.751 0 0 0-.978-.072l-.084.073a.75.75 0 0 0 0 1.061l.14.141-6.934 6.934a.749.749 0 0 1-1.06.004l-1.868-1.85a.753.753 0 0 1-.002-1.065 1.419 1.419 0 0 0 0-2.003 1.418 1.418 0 0 0-2.003 0 .785.785 0 0 1-.532.22c-.2 0-.39-.08-.533-.222l-1.85-1.868a.75.75 0 0 1 .003-1.06L7.155 5l.14.14a.75.75 0 0 0 .414.211l.118.01a.75.75 0 0 0 .53-1.283l-.14-.14L11.935.22a.789.789 0 0 1 .537-.22zm-2.197 6.004a.751.751 0 0 0-1.063 1.062l3.73 3.73a.75.75 0 0 0 1.062-1.063z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#6173FE",
    fillRule: "nonzero",
    xlinkHref: "#a",
    transform: "translate(2 2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/icon-ticket.c93b7b0d.svg";
export { ForwardRef as ReactComponent };